import { MultiToggle } from "PFComponents/multi_toggle";
import { useTranslation } from "react-i18next";

import { ConversationType } from "./conversation_type_selector.types";

type ConversationTypeSelectorProps = {
  isDisabled?: boolean;
  conversationType: ConversationType;
  onConversationTypeChange: (id: ConversationType) => void;
};

export const ConversationTypeSelector = ({
  isDisabled,
  conversationType,
  onConversationTypeChange
}: ConversationTypeSelectorProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.conversation" });

  const options = [
    {
      id: ConversationType.Direct,
      value: t("oneToOnePrivate"),
      title: t("oneToOnePrivate"),
      disabled: isDisabled
    },
    {
      id: ConversationType.Group,
      value: t("groupConversation"),
      title: t("groupConversation"),
      disabled: isDisabled
    }
  ];

  return (
    <MultiToggle<ConversationType>
      options={options}
      controlledValue={conversationType}
      onChange={onConversationTypeChange}
      fluid
    />
  );
};
